<template> 
  <div class="container">
    <div class="page-header">
      <h1 class="page-title full">
        Paramètres du compte<br>
      </h1>
    </div>
    <div class="row row-cards">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Modifier le mot de passe</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label class="form-label">Mot de passe</label>
                  <input type="password" class="form-control" v-model="mot_de_passe" name="mot_passe" v-validate="'required'" 
                    :class="{ 'is-invalid': errors.has('mot_passe') }" data-vv-as="Le mot de passe" ref="password">
                  <div class="invalid-feedback" v-show="errors.has('mot_passe')&&showErrors">{{ errors.first('mot_passe') }}</div>
                </div>
                <div class="form-group">
                  <label class="form-label">Confirmer le mot de passe</label>
                  <input type="password" class="form-control" name="mot_passe_conf" v-validate="'confirmed:password'" 
                    :class="{ 'is-invalid': errors.has('mot_passe_conf') }" data-vv-as="La confirmation">
                  <div class="invalid-feedback" v-show="errors.has('mot_passe_conf')&&showErrors">{{ errors.first('mot_passe_conf') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-12 p-2">
                <button type="submit" class="btn btn-primary" v-on:click.prevent="saveMotDePasse()">
                  Sauvegarder
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        mot_de_passe: '',
        showErrors: false
      }
    },
    created () {
      this.$store.commit("setTitle", "Modifier le mot de passe");
    },
    methods: {
      saveMotDePasse() {
        var self = this;
        self.showErrors = true;
        self.$validator.validateAll().then((result) => {
          if (result) {
            self.$http.post('auth/update_password', {
              new_pass: self.mot_de_passe
            }).then(response => {
              if (response.status == 200) {
                self.$notify.success("Le mot de passe a été modifié.");
                self.$router.push({ name: 'Horaires' });
              }
            }, response => {
              // error callback
              self.$notify.error("Une erreur est survenue.");
            });
          }
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// MotPasseEdit.vue?0de87da1